const syncAriaHiddenFocus = (slider) => {
  const focusableSelector =
    'a, button, input, select, textarea, [tabindex]:not([tabindex="-1"])';

  const update = () => {
    slider.slides.forEach((slide) => {
      const isHidden = slide.getAttribute("aria-hidden") === "true";
      const focusables = slide.querySelectorAll(focusableSelector);

      if (isHidden) {
        slide.setAttribute("inert", "");
        focusables.forEach((el) => {
          if (el.hasAttribute("data-prev-tabindex")) return;
          const prev = el.getAttribute("tabindex");
          el.setAttribute("data-prev-tabindex", prev === null ? "" : prev);
          el.setAttribute("tabindex", "-1");
        });
      } else {
        slide.removeAttribute("inert");
        focusables.forEach((el) => {
          if (!el.hasAttribute("data-prev-tabindex")) return;
          const prev = el.getAttribute("data-prev-tabindex");
          if (prev === "") {
            el.removeAttribute("tabindex");
          } else {
            el.setAttribute("tabindex", prev);
          }
          el.removeAttribute("data-prev-tabindex");
        });
      }
    });
  };

  slider.on("created", update);
  slider.on("detailsChanged", update);
  slider.on("slideChanged", update);
  slider.on("updated", update);
};

// Progress bar slider initializer using Keen Slider
// No loop, no autoplay; preserves progress bar logic.
if (window.Drupal && window.once) {
  (function (Drupal, once) {
    "use strict";

    Drupal.behaviors.progressBarSliderInit = {
      attach: function (context) {
        try {
          const selector = ".js-progress-bar-keen-slider";
          once("progress-bar-slider-init", selector, context).forEach(function (
            container
          ) {
            if (!(window.keen && window.keen.KeenSlider)) return;

            // Avoid conflict: if this container is used by the announcements slider,
            // or is inside an announcements slider region, skip initializing here.
            if (
              (container.classList &&
                container.classList.contains("js-fader-keen")) ||
              (typeof container.closest === "function" &&
                container.closest("[data-fader-slider]"))
            ) {
              return;
            }

            const wrapper = container.closest(".keen-slider-region");
            const progressBar = wrapper
              ? wrapper.querySelector(".progress-bar")
              : null;
            const thumb = progressBar
              ? progressBar.querySelector(".progress-bar__thumb")
              : null;

            const plugins = [
              window.keen.Keyboard,
              window.keen.Accessibility,
              syncAriaHiddenFocus,
            ];
            if (wrapper && wrapper.querySelector(".keen-slider__arrows")) {
              plugins.push(window.keen.Arrows);
            }
            if (
              wrapper &&
              wrapper.querySelector(".keen-slider__bullets-list")
            ) {
              plugins.push(window.keen.Bullets);
            }

            function updateThumbFromSlider(slider) {
              if (!thumb) return;
              const details = slider.track.details;
              if (!details) return;
              const totalSlides = details.slides.length || 1;
              const configuredPerView =
                slider.options &&
                slider.options.slides &&
                slider.options.slides.perView;
              const perView = Math.max(1, Number(configuredPerView) || 1);

              const widthPercent = Math.min(
                100,
                Math.max(0, (perView / totalSlides) * 100)
              );
              const minIdx =
                typeof details.minIdx === "number" ? details.minIdx : 0;
              const maxIdx =
                typeof details.maxIdx === "number"
                  ? details.maxIdx
                  : Math.max(0, totalSlides - Math.ceil(perView));
              const span = Math.max(0, maxIdx - minIdx);
              const rel = Math.min(
                Math.max((details.rel || 0) - minIdx, 0),
                span
              );
              const leftPercent =
                span > 0 ? (rel / span) * (100 - widthPercent) : 0;
              thumb.style.width = widthPercent + "%";
              thumb.style.left = leftPercent + "%";
            }

            new window.keen.KeenSlider(
              container,
              {
                loop: false,
                renderMode: "precision",
                rubberband: false,
                slides: { perView: 1.2, spacing: window.keen.gridSpacing },
                breakpoints: {
                  [window.keen.minBreakpoint("sm")]: {
                    slides: { perView: 1.2, spacing: window.keen.gridSpacing },
                  },
                  [window.keen.minBreakpoint("md")]: {
                    slides: { perView: 2.2, spacing: window.keen.gridSpacing },
                  },
                  [window.keen.minBreakpoint("lg")]: {
                    slides: { perView: 2.5, spacing: window.keen.gridSpacing },
                  },
                  [window.keen.minBreakpoint("xl")]: {
                    slides: { perView: 3.2, spacing: window.keen.gridSpacing },
                  },
                },
              },
              [
                ...plugins,
                function (slider) {
                  slider.on("created", function () {
                    updateThumbFromSlider(slider);
                  });
                  slider.on("slideChanged", function () {
                    updateThumbFromSlider(slider);
                  });
                  slider.on("updated", function () {
                    updateThumbFromSlider(slider);
                  });
                  window.addEventListener("resize", function () {
                    updateThumbFromSlider(slider);
                  });
                },
              ]
            );
          });
        } catch (e) {
          // no-op
        }
      },
    };
  })(window.Drupal, window.once);
}
